const bullets = [
  { label: 'Right expertise, every time', detail: 'Access to the right expertise for the problem — not a generalist bench.' },
  { label: 'Rigorous technical vetting', detail: 'Structured evaluation and expert review at every stage of the engagement.' },
  { label: 'Global coordination', detail: 'Clear delivery across teams, geographies, and disciplines — without friction.' },
];

export default function WhyRG() {
  return (
    <section id="about" className="py-24 px-6">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16">
        <div>
          <h2 className="text-3xl md:text-4xl font-700 tracking-tight text-brand-text leading-snug">
            Why organizations trust<br />RG Consulting
          </h2>
        </div>
        <div>
          <p className="text-brand-text/60 leading-relaxed mb-10">
            We combine technical depth, cross-border coordination, and practical engineering judgment to help clients make high-stakes decisions with confidence.
          </p>
          <ul className="flex flex-col gap-0 divide-y divide-brand-gray">
            {bullets.map((b, i) => (
              <li key={b.label} className="flex gap-5 py-5">
                <span className="text-xs font-semibold text-brand-blue tabular-nums mt-0.5 w-5 flex-shrink-0">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <div className="flex flex-col gap-1">
                  <span className="text-sm font-semibold text-brand-text">{b.label}</span>
                  <span className="text-sm text-brand-text/55 leading-relaxed">{b.detail}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
